import { useQuery } from "@tanstack/react-query";
import { getWallets } from "../api";
import { useAuthStore } from "@/store/useAuthStore";

export function useWallets(networkId?: number) {
  const token = useAuthStore((state) => state.token);

  return useQuery({
    queryKey: ["wallets", networkId],
    queryFn: () => getWallets({ network: networkId }),
    enabled: !!token,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
